<template>
  <div class="c-page-title">
    <h1 class="c-page-title__heading">
      <slot></slot>
    </h1>
    <p class="c-page-title__subtitle" v-if="subTitle">{{subTitle}}</p>
  </div>
</template>

<script>
export default {
  name: 'page-title',

  props: ['title', 'subTitle'],
};
</script>

<style lang="scss">
.c-page-title {
  margin: 0.5em 0;
  text-align: center;
  padding: 20px 0;

  @media (min-width: 768px) {
    padding: 0 0 20px;
  }

  &__heading {
    font-size: 24px;
    margin: 0;
    color: #0054a5;
  }

  &__subtitle {
    margin: 0;
    margin-top: 0.5em;
    margin-bottom: 1em;
  }

  @media screen and (min-width: 768px) {
    margin: 1em 0;
    text-align: left;

    &__heading {
      font-size: 30px;
    }
  }
}
</style>
